import React, { Fragment, useCallback, useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import './tableIcon.css' 
const ItDataTable = ({ staticData, tableColumns, onRowClick }) => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    const [data, setData] = useState(staticData);

    console.log('it data table', staticData) 

    // Parse "YYYY-MM-DD HH:MM AM/PM" -> Date
const parse12h = (s) => {
  if (!s || typeof s !== "string") return null;
  const m = s.match(
    /^(\d{4})-(\d{2})-(\d{2})\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)$/i
  );
  if (!m) return null;

  let [_, yyyy, MM, dd, hh, mm, ss = "0", mer] = m;
  let H = parseInt(hh, 10);
  if (mer.toUpperCase() === "PM" && H !== 12) H += 12;
  if (mer.toUpperCase() === "AM" && H === 12) H = 0;

  return new Date(
    Number(yyyy),
    Number(MM) - 1,
    Number(dd),
    H,
    Number(mm),
    Number(ss)
  );
};

const latestMillis = (row) => {
  const a = parse12h(row.loginTime)?.getTime() ?? -Infinity;
  const b = parse12h(row.logoutTime)?.getTime() ?? -Infinity;
  return Math.max(a, b);
};

// If you want a new sorted array:
const staticDataa = [...staticData].sort(
  (x, y) => latestMillis(y) - latestMillis(x)
);

// NEW: convert UTC "YYYY-MM-DD HH:MM AM/PM" to local time (date kept as-is)
const convertUtcToLocalKeepDate = (s) => {
  if (!s || typeof s !== "string") return s;
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})\s+(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)$/i);
  if (!m) return s;

  const [, yyyy, MM, dd, hh, mm, ss = "0", mer] = m;
  let H = parseInt(hh, 10);
  if (mer.toUpperCase() === "PM" && H !== 12) H += 12;
  if (mer.toUpperCase() === "AM" && H === 12) H = 0;

  const utcMs = Date.UTC(+yyyy, +MM - 1, +dd, H, +mm, +ss);
  const local = new Date(utcMs);

  let Hloc = local.getHours();
  const ampm = Hloc >= 12 ? "PM" : "AM";
  Hloc = Hloc % 12 || 12;

  const hh12 = String(Hloc).padStart(2, "0");
  const mm2 = String(local.getMinutes()).padStart(2, "0");
  const ss2 = String(local.getSeconds()).padStart(2, "0");

  return `${yyyy}-${MM}-${dd} ${hh12}:${mm2}${m[6] ? `:${ss2}` : ""} ${ampm}`;
};

// apply conversion BEFORE sorting (date unchanged, time localized)
const staticDataaa = staticDataa
  .map(row => ({
    ...row,
    loginTime: convertUtcToLocalKeepDate(row.loginTime),
    logoutTime: convertUtcToLocalKeepDate(row.logoutTime),
  }))
  .sort((x, y) => latestMillis(y) - latestMillis(x));


// If staticData is React state and you want to set it in place:
// setStaticData(prev => [...prev].sort((x, y) => latestMillis(y) - latestMillis(x)));


    const handleRowClick = (row) => {
        if (onRowClick && typeof onRowClick === 'function') {
            onRowClick(row); 
        } else {
            console.error('onRowClick is not a function');
        }
    };

    useEffect(() => { 
        setData(staticDataaa);
    }, [staticData]);

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleDelete = () => {
        if (window.confirm(`Are you sure you want to delete:\r ${selectedRows.map(r => r.name)}?`)) {
            setToggleDelet(!toggleDelet);
            setData(data.filter(item => !selectedRows.some(elem => elem.id === item.id)));
            setSelectedRows([]);
        }
    };
    const customStyles = {
      tableWrapper: {
        style: {
          borderRadius: "20px 20px 0 0", // Top left and right border-radius for the wrapper
          overflow: "hidden", // Ensure rounded corners are visible
        },
      },
      table: {
        style: { 
          backgroundColor: "transparent", // Set the table background to transparent
          borderRadius: "20px 20px 0 0", // Apply top left and right border-radius to the table
          overflow: "hidden", // Ensure the table content fits within the rounded corners
        },
      },
      headRow: {
        style: {  
          backgroundColor: "transparent", // Set the header row background to transparent
          borderTopLeftRadius: '20px', // Top left corner radius
          borderTopRightRadius: '20px', // Top right corner radius
          borderBottom: '2px solid #e0e0e0', // Optional: Add a subtle bottom border
        },
      },
      rows: {
        style: {
          backgroundColor: "transparent", // Set the row background to transparent 
          wordBreak: "break-word",
          wordWrap: "break-word",
          overflow: "visible", 
        },
      },
      cells: {
        style: {
          backgroundColor: "transparent", // Set the cell background to transparent
          wordBreak: "break-word",
          wordWrap: "break-word",
          overflow: "visible",
        },
      },
      headCells: {
        style: {
          fontWeight: 'bold', // Bold header text
          backgroundColor: "transparent", // Set the header cell background to transparent
        },
      },
    };
    
    
    

    return (
        <Fragment>
            {/* {selectedRows.length > 0 && (
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delete Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: handleDelete }}>Delete</Btn>
                </div>
            )} */} 
            <DataTable
  data={data}
  columns={tableColumns}
  striped={false}
  center={true}
  pagination 
  onRowClicked={handleRowClick}
  customStyles={
    customStyles
  }
/>
   
 




        </Fragment>
    );
};

export default ItDataTable;
 
